import { jsx as _jsx } from "react/jsx-runtime";
import { ImageContainerShape, renderFactionEmblem } from './image/index.js';
import { IconListEntry } from './IconListEntry.js';
export function FactionListEntry(props) {
    const { factionName, onClick, button, dense } = props;
    const factionEmblem = renderFactionEmblem(factionName, {
        maxHeightInPixels: 45,
        maxWidthInPixels: 45,
        containerShape: ImageContainerShape.Circle,
    });
    return (_jsx(IconListEntry, { icon: factionEmblem, primaryText: factionName, onClick: onClick, button: button, dense: dense }));
}
//# sourceMappingURL=FactionListEntry.js.map